/**
 * GA4 conversion event helpers.
 * Call these at key user milestones so GA4 can track conversion funnels.
 * Safe to call even when GA4 is not configured — all calls are no-ops without gtag.
 */

const track = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

export const trackSignUp = (method = 'email') => {
  track('sign_up', { method });
};

export const trackLogin = (method = 'email') => {
  track('login', { method });
};

export const trackMonitorCreated = (facilityId) => {
  track('monitor_created', { facility_id: facilityId });
};

export const trackSubscriptionUpgrade = (tier, value) => {
  track('purchase', {
    currency: 'USD',
    value: value || 0,
    items: [{ item_name: `Camp Scout ${tier}`, item_category: 'subscription' }]
  });
};

export const trackAutoBookingCreated = (facilityId) => {
  track('auto_booking_created', { facility_id: facilityId });
};
